export class IntlFormatter {
  private currencyFormatter: Intl.NumberFormat;

  constructor(
    locale = 'fr-FR',
    { trailingZeroDisplay }: { trailingZeroDisplay: 'auto' | 'stripIfInteger' },
  ) {
    this.currencyFormatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      // @ts-expect-error need to upgrade TypeScript
      trailingZeroDisplay,
    });
  }

  formatCurrency(value: number): string {
    return this.currencyFormatter.format(value);
  }
}
